import Vue from 'vue'
import Vuex from 'vuex'
import iview from 'iview'

import { getToken } from '@/libs/util'
import app from './module/app'
import department from './module/department'
import user from './module/user'
import staff from './module/staff'
import machine from './module/machine'
import project from './module/project'
import {
  HomeData, GetStatistics, GetJobRecord, GetChartData, GetJobPie,
  GetDepartmentTrend, GetStaffTrend, GetMachineTrend, GetRechargeLog, DeleteRechargeLog
} from '@/api/data'

Vue.use(Vuex)

let connSocket = (commit, self) => {
  if (!getToken()) {
    return
  }
  let socket = new WebSocket(`${process.env.NODE_ENV === "development" ? 'wss://socket.aidprint.com' : 'wss://socket.aidprint.com'}/websocket?company=${getToken()}`)
  socket.onopen = () => {
    commit('SET_SOCKET', socket)
  }
  socket.onclose = () => {
    // commit("SET_SOCKET",false)
    setTimeout(() => {
      connSocket(commit, self)
    }, 2000)
  }
  socket.onmessage = (e) => {
    let data = JSON.parse(e.data)
    switch (data.action) {
      // 设备状态
      case 100000:
        self.state.machine.machine.map(item => {
          item.machine_status = data.data[item.sn]
        })
        break
      // 获取设备信息
      case 100001:
        let toner = [],
          tray = []
        let nameObj = {
          black: "黑色",
          magenta: "红色",
          yellow: "黄色",
          cyan: "青色",
          manual: "手送台",
          tray1: "纸盒1",
          tray2: "纸盒2",
          tray3: "纸盒3",
          tray4: "纸盒4"
        };
        try {
          data.value.toner.map(item => {
            toner.push({ name: nameObj[item.split('_')[0]], value: parseInt(item.split('_')[1]) })
          })
          data.value.tray.map(item => {
            tray.push({ name: nameObj[item.split('_')[0]], value: parseInt(item.split('_')[1]) })
          })
          self.state.machine_info = {
            tray: tray,
            toner: toner
          }
        } catch (error) {
          iview.Message.error('设备已断线')
        }
        break
      // 设备连接与断开
      case 100002:
        self.state.machine.machine.map(item => {
          if (data.id) {
            if (item.id === data.id) {
              item.machine_status = data.machine_status
            }
          } else if (data.sn) {
            if (item.sn === data.sn) {
              item.machine_status = data.machine_status
            }
          }
        })
        break
      case 100003:
        self.state.machine.machine.map(item => {
          if (item.sn === data.sn) {
            item.machine_status = 1
          }
        })
        break
      case 100004:
        self.state.machine.machine.map(item => {
          if (item.id === data.machine_id) {
            item.errors = data.error;
          }
        })
        break
      default:
        break
    }
  }
}

export default new Vuex.Store({
  state: {
    socket: false,
    machine_info: false
  },
  getters: {
    socket: state => state.socket,
    machine_info: state => state.machine_info
  },
  actions: {
    InitMachineInfo({ commit }, payload) {
      this.state.machine_info = false
    },
    // socket 连接
    SocketConn({ commit }, payload) {
      return new Promise(resolve => {
        connSocket(commit, this)
        resolve()
      })
    },
    // socket 发送消息
    SocketSend({ commit }, payload) {
      try {
        if (this.state.socket) {
          this.state.socket.send(JSON.stringify(payload))
        } else {
          connSocket(commit, this)
          setTimeout(() => {
            this.state.socket.send(JSON.stringify(payload))
          }, 100)
        }
      } catch (error) {

      }
    },
    HomeData({ commit }, payload) {
      return new Promise(resolve => {
        HomeData(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetStatistics({ commit }, payload) {
      return new Promise(resolve => {
        GetStatistics(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetJobRecord({ commit }, payload) {
      return new Promise(resolve => {
        GetJobRecord(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetChartData({ commit }, payload) {
      return new Promise(resolve => {
        GetChartData(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetJobPie({ commit }, payload) {
      return new Promise(resolve => {
        GetJobPie(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDepartmentTrend({ commit }, payload) {
      return new Promise(resolve => {
        GetDepartmentTrend(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetStaffTrend({ commit }, payload) {
      return new Promise(resolve => {
        GetStaffTrend(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineTrend({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineTrend(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetRechargeLog({ commit }, payload) {
      return new Promise(resolve => {
        GetRechargeLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DeleteRechargeLog({ commit }, payload) {
      return new Promise(resolve => {
        DeleteRechargeLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  mutations: {
    SET_SOCKET(state, payload) {
      state.socket = payload
    }
  },
  modules: {
    app,
    department,
    user,
    staff,
    machine,
    project
  }
})
